import clsx from 'clsx';
import React from 'react';
import styles from './UIGameCard.module.scss';
import { PlayerColor } from '@colonist/game-states';
import { T, Tooltip } from '@colonist/ui';
import { UIGameCount } from '../UIGameCount/UIGameCount.tsx';
import { CARD_IMAGES, CARD_TIP_BODY, CARD_TIP_TITLE } from '@colonist/ui-game';
import { passThroughTranslation } from '@colonist/i18n';
import { UIGameFloatingText } from '../UIGameFloatingText/UIGameFloatingText.tsx';
import { useUIGameTranslationContext } from '../../contexts/UIGameTranslationContext.tsx';
const CountBadge = ({ count, size })=>/*#__PURE__*/ React.createElement(UIGameCount, {
        className: styles.countBadge,
        color: PlayerColor.Blue,
        count: count,
        size: size
    });
const RatioBanner = ({ tradeRatio })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.ratioBanner
    }, /*#__PURE__*/ React.createElement(T, {
        id: passThroughTranslation(`${tradeRatio}:1`)
    }));
const CardContent = ({ className, cardEnum, onClick, count, tradeRatio, isDisabled, isGreyedOut, highlightAnimation, size, bounceAnimation })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.cardContainer, styles[size], {
            [styles.clickable]: onClick != undefined,
            [styles.isDisabled]: isDisabled,
            [styles.highlight]: highlightAnimation,
            [styles.bounce]: bounceAnimation
        }, className),
        onClick: onClick,
        "data-card-enum": cardEnum
    }, /*#__PURE__*/ React.createElement("img", {
        draggable: false,
        className: clsx(styles.cardImage, {
            [styles.isGreyedOut]: isGreyedOut
        }),
        src: CARD_IMAGES[cardEnum]
    }), count != undefined && /*#__PURE__*/ React.createElement(CountBadge, {
        count: count,
        size: size
    }), tradeRatio != undefined && /*#__PURE__*/ React.createElement(RatioBanner, {
        tradeRatio: tradeRatio
    }));
const UIGameCardComponent = ({ className = '', cardEnum, showTipTitle = false, showTipBody = false, onClick, count = undefined, tooltipPosition = 'top', tradeRatio, isDisabled, isGreyedOut, highlightAnimation, bounceAnimation, helperText, size = 'base', customTooltip })=>{
    const { translationKeyContext } = useUIGameTranslationContext();
    const handleClick = onClick ? ()=>onClick(cardEnum) : undefined;
    const hasHelperText = helperText != null;
    const hasCustomTooltip = customTooltip != null;
    const hasTooltip = hasCustomTooltip || showTipTitle || showTipBody;
    const tipBody = {
        ...CARD_TIP_BODY[cardEnum],
        options: {
            context: translationKeyContext
        }
    };
    const tipTitle = {
        ...CARD_TIP_TITLE[cardEnum],
        options: {
            context: translationKeyContext
        }
    };
    const cardContent = /*#__PURE__*/ React.createElement(CardContent, {
        className: className,
        count: count,
        cardEnum: cardEnum,
        onClick: handleClick,
        tradeRatio: tradeRatio,
        isDisabled: isDisabled,
        isGreyedOut: isGreyedOut,
        highlightAnimation: highlightAnimation,
        size: size,
        bounceAnimation: bounceAnimation
    });
    if (hasCustomTooltip) {
        return /*#__PURE__*/ React.createElement(Tooltip, {
            centerText: customTooltip.centerText,
            content: customTooltip.content,
            menuClassName: styles.tooltipMenu,
            position: tooltipPosition,
            title: customTooltip.title
        }, hasHelperText ? /*#__PURE__*/ React.createElement(UIGameFloatingText, {
            direction: "up",
            text: helperText
        }, cardContent) : cardContent);
    }
    if (hasTooltip && hasHelperText) {
        return /*#__PURE__*/ React.createElement(Tooltip, {
            centerText: false,
            content: showTipBody ? /*#__PURE__*/ React.createElement(T, {
                id: tipBody
            }) : undefined,
            menuClassName: styles.tooltipMenu,
            position: tooltipPosition,
            title: showTipTitle ? /*#__PURE__*/ React.createElement(T, {
                id: tipTitle
            }) : undefined
        }, /*#__PURE__*/ React.createElement(UIGameFloatingText, {
            direction: "up",
            text: helperText
        }, cardContent));
    }
    if (hasTooltip) {
        return /*#__PURE__*/ React.createElement(Tooltip, {
            centerText: false,
            content: showTipBody ? /*#__PURE__*/ React.createElement(T, {
                id: tipBody
            }) : undefined,
            menuClassName: styles.tooltipMenu,
            position: tooltipPosition,
            title: showTipTitle ? /*#__PURE__*/ React.createElement(T, {
                id: tipTitle
            }) : undefined
        }, cardContent);
    }
    if (hasHelperText) {
        return /*#__PURE__*/ React.createElement(UIGameFloatingText, {
            direction: "up",
            text: helperText
        }, cardContent);
    }
    return cardContent;
};
export const UIGameCard = /*#__PURE__*/ React.memo(UIGameCardComponent);
